import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Form, Input, message, Card, Select, Button, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import "dayjs/locale/en";
import { UploadFile } from "antd/lib/upload";
import Upload from "antd/es/upload";
import { BiSolidInbox, BiUpload } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { AuthContext } from "../../Auth/AuthContext";
import { useParams } from "react-router-dom";
import { getCustomerByID, editCustomer } from "../../utils/API";
import { ArrowLeftOutlined, UploadOutlined } from "@ant-design/icons";

interface EditCustomersModalProps {
  visible: boolean;
  taskId?: string;
  customerId?: string;
  onClose?: () => void;
  onEdit?: () => void;
  onCancel?: () => void;
  onSuccess?: () => void;
}
const EditCustomersModal: React.FC<EditCustomersModalProps> = (props) => {
  const navigate = useNavigate();
  const { Option } = Select;
  const { visible, onCancel, taskId, onClose, customerId } = props;
  const { id } = useParams();
  const { authData } = useContext(AuthContext);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = React.useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [profilePhoto, setPhoto] = useState<File | null>(null);
  const [documents, setDocuments] = useState<File[]>([]);
  const [customerData, setCustomerData] = useState<EditCustomersModalProps>();
  const [showAdminContact, setShowAdminContact] = useState(false);
  const [Customer, setCustomerr] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const IMAGEURL = process.env.REACT_APP_IMAGE_URL + "/customers/";

  const roleId = authData.roleId;


  const fetchCustomer = async () => {
    if (!customerId) return;

    setIsLoading(true);
    try {
      const data = await getCustomerByID(customerId);
      setCustomerData(data);

      // Wait for form to be ready before setting values
      if (form) {
        form.setFieldsValue({
          name: data.name,
          mobile: data.mobile,
          companyName: data.companyName,
          email: data.email,
          profilePhoto: data.profilePhoto
        });
      }

      // Set image preview
      if (data.profilePhoto) {
        const imagePath = `${IMAGEURL}${data.profilePhoto}`;
        setPreviewImage(imagePath);
        setFileList([{
          uid: "-1",
          name: data.profilePhoto,
          status: "done",
          url: imagePath,
        }]);
      }
    } catch (error) {
      message.error("Failed to fetch customer data.");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchCustomer();
  }, [customerId]);

  const getBase64 = (file: File | Blob) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  const imageProps = {
    name: 'image',
    multiple: false,
    beforeUpload(file: any) {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        message.error('You can only upload image files!');
      }
      const isLt64M = file.size / 1024 / 1024 < 64;
      if (!isLt64M) {
        message.error('Image must be smaller than 64MB!');
      }
      return isImage && isLt64M;
    },
    onChange(info: any) {
      const newFileList = [...info.fileList];
      if (newFileList.length > 0) {
        const file = newFileList[0];
        if (!file.url && !file.preview) {
          getBase64(file.originFileObj).then((preview) => {
            file.preview = preview;
            setPreviewImage(preview);
            setPhoto(file.originFileObj); // Set the photo state with the selected file
          });
        } else {
          setPreviewImage(file.url || file.preview || '');
          setPhoto(file.originFileObj); // Set the photo state with the selected file
        }
      } else {
        setPreviewImage('');
        setPhoto(null); // Reset the photo state if no file is selected
      }
      setFileList(newFileList.slice(-1)); // Only keep the last uploaded file
    },
    fileList,
  };

  const handleSubmit = async (values: any) => {
    if (!customerId) {
      message.error("Customer ID is missing!");
      return;
    }

    setIsSaving(true);
    try {
      const formData = new FormData();
      formData.append("id", customerId);

      // Append other fields
      Object.keys(values).forEach(key => {
        if (key !== 'profilePhoto') {
          formData.append(key, values[key]);
        }
      });

      if (profilePhoto) {
        formData.append("profilePhoto", profilePhoto);
      }

      await editCustomer(formData);
      message.success("Customer updated successfully!");
      if (props.onSuccess) props.onSuccess();
    } catch (error) {
      message.error("Failed to update customer.");
    } finally {
      setIsSaving(false);
    }
  };
  return (
    <>
      <Modal

        visible={visible}
        onCancel={onClose}
        footer={null}
        width={600}
        centered // Disable centered to use top positioning
        destroyOnClose
        className="custom-modal"
        bodyStyle={{
          overflowY: "auto",
          fontFamily: "inter, sans-serif",
        }}
        styles={{
          header: {
            padding: "12px",
            position: "sticky",
            top: 0,
            backgroundColor: "#f1f5ffff",
          },
          content: {
            padding: 0,
            overflow: "hidden",
          },
        }}
        title={
          <div
            style={{
              color: "#4b5563",
              fontFamily: "inter, sans-serif",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            Edit Customer
          </div>
        }
      >
        <Form
          onFinish={handleSubmit}
          form={form}
          layout="horizontal"
          // className=""
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 20 }}
          colon={false}
          style={{ margin: "0" }}
        >
          <div className="elements">
            <Form.Item
              colon={true}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              className="w-full"
            >
              <div className="flex justify-center ">
                <div className="relative w-20 h-20">
                  <Upload.Dragger
                    {...imageProps}
                    className="w-full h-full rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center hover:border-blue-500 transition-colors bg-gray-50 overflow-hidden"
                    showUploadList={false}
                  >
                    {!previewImage ? (
                      <div className="flex flex-col items-center p-1">
                        <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center">
                          <UploadOutlined className="text-gray-400 text-base" />
                        </div>
                        <span className="text-xs text-gray-400 mt-1">Profile</span>
                      </div>

                    ) : (
                      <img
                        src={previewImage}
                        alt="Uploaded"
                        className="w-full h-full object-cover"
                      />
                    )}
                  </Upload.Dragger>

                  {previewImage && (
                    <Button
                      type="text"
                      shape="circle"
                      size="small"
                      icon={<MdDeleteOutline size={16} />}
                      className="absolute top-0 right-0 bg-red-500 text-white hover:bg-red-600 shadow-sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        setPreviewImage("");
                        setFileList([]);
                      }}
                    />
                  )}
                </div>
              </div>
            </Form.Item>
            <Form.Item
              label={<span style={{
                color: '#4b5563', // Medium gray color similar to the image
                fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
                fontSize: '14px', // Approximate font size based on the image
                paddingLeft: "15px",
                fontWeight: 500, // Medium weight to match "font-medium"
              }}>Name <span className="text-danger">*</span></span>}
              name="name"
              required={false}
              rules={[{ required: true, message: "Please Enter Name" }]}
            >
              <Input
                size="large"
                disabled={roleId == 2}
                placeholder="Enter name"
                className="Allinput"
              />
            </Form.Item>
            <Form.Item
              label={<span style={{
                color: '#4b5563', // Medium gray color similar to the image
                fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
                fontSize: '14px', // Approximate font size based on the image
                paddingLeft: "15px",
                fontWeight: 500, // Medium weight to match "font-medium"
              }}>Mobile No. <span className="text-danger">*</span></span>}
              name="mobile"
              required={false}
              rules={[
                { required: true, message: "Please Enter Mobile No." },
                // { pattern: /^[0-9]{10}$/, message: "Enter a valid 10-digit number" },
              ]}
            >
              <Input
                size="large"
                disabled={roleId == 2}
                placeholder="Enter mobile number"
                className="Allinput"
              />
            </Form.Item>
            <Form.Item
              label={<span style={{
                color: '#4b5563', // Medium gray color similar to the image
                fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
                fontSize: '14px', // Approximate font size based on the image
                paddingLeft: "15px",
                fontWeight: 500, // Medium weight to match "font-medium"
              }}>Company Name <span className="text-danger">*</span></span>}
              name="companyName"
              required={false}
              rules={[{ required: true, message: "Please Enter Company Name" }]}
            >
              <Input
                size="large"
                disabled={roleId == 2}
                placeholder="Enter company name"
                className="Allinput"
              />
            </Form.Item>
            <Form.Item
              label={<span style={{
                color: '#4b5563', // Medium gray color similar to the image
                fontFamily: 'inter, sans-serif', // Matches the clean sans-serif style
                fontSize: '14px', // Approximate font size based on the image
                paddingLeft: "15px",
                fontWeight: 500, // Medium weight to match "font-medium"
              }}>Email <span className="text-danger">*</span></span>}
              name="email"
              required={false}
              rules={[
                { required: true, message: "Please Enter Email" },
                { type: "email", message: "Enter a valid email address" },
              ]}
            >
              <Input
                size="large"
                disabled={roleId == 2}
                placeholder="Enter email address"
                className="Allinput"
              />
            </Form.Item>
          </div>

          <Col
            xs={24}
            sm={24}
            md={24}
            xl={24}
            xxl={20}
            className="d-flex justify-content-end me-3 mt-3"
          >
            <div className="button-wrapper">
              <button
                className="allcanclebutton"
                type="button" // Important change
                onClick={(e) => {
                  e.preventDefault();
                  onClose?.();
                }}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                className="allsubmitebutton "
                style={{ width: "10vw" }}
                type="submit" // Ensure this is a submit button
                disabled={isLoading || isSaving}
              >
                {isSaving ? "Updating..." : "Update"}
              </button>
            </div>
          </Col>
        </Form>
      </Modal >
    </>
  );
};

export default EditCustomersModal;
